import React from 'react'
import Dropdown from 'react-bootstrap/Dropdown';

function Businessdropdown() {
    return (<>
        <Dropdown style={{ width: "120px" }}>
            <Dropdown.Toggle className='dropdown-btns' variant="success" id="dropdown-basic">
                All
            </Dropdown.Toggle>

            <Dropdown.Menu className='mt-3 ps-2 pe-2 '>
                <Dropdown.Item className='drop_item' href="#/action-1">All</Dropdown.Item>
                <Dropdown.Item href="#/action-2" className='drop_item'>By State</Dropdown.Item>
                <Dropdown.Item href="#/action-3" className='drop_item'>By Zip</Dropdown.Item>
                <Dropdown.Item href="#/action-3" className='drop_item'>By Date</Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>






    </>

    )
}

export default Businessdropdown